import React from "react";
import styles from './styles/SessionExists.module.css'
import { formatDate } from "../../../Utils/formatDate";

export function SessionExists ({title, message, login_data, onclick, button_message, login_time_text="Login Time", device_text="Device"}){
    console.log(login_data)
    return(
        <div className={styles.background}>
            <div className={styles.main}>
                <div className={styles.title}>{title}</div>
                <div className={styles.message}>{message}</div>
                {login_data&&<div className={styles.login_data_body}>
                    <div className={styles.div_flex}>
                        <div className={styles.data_title}>{login_time_text}:</div>
                        <div className={styles.data_value}>{formatDate(Number(login_data?.login))}</div>
                    </div>
                    <div className={styles.div_flex}>
                        <div className={styles.data_title}>{device_text}:</div>
                        <div className={styles.data_value}>{login_data?.device_model}</div>
                    </div>
                    <div className={styles.div_flex}>
                        <div className={styles.data_title}>IP:</div>
                        <div className={styles.data_value}>{login_data?.remote_ip}</div>
                    </div>
                </div>}
                <button onClick={onclick} className={styles.button}>{button_message}</button>
            </div>
        </div>
    )
}